import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPictreePhotoShootByAssetTepco,
  getPictreePhotoShootTrendByAssetTepco,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import PhotoShootAssetType from "components/PicTree/Home/PhotoShootAssetType";
import ChartConfig from "utils/ChartConfig";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";
import PicTreeTablePhotoSubType from "components/Table/PicTreeTablePhotoSubType";
import CalendarRangePicker from "components/Calendar/CalendarRangePicker";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreeReviewByAssetTypeTepco = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTree,
  getPictreePhotoShootByAssetTepco,
  photoShootTrendByAsset,
  getPictreePhotoShootTrendByAssetTepco,
}) => {
  const classes = useStyles();
  const [chartState, setChartState] = useState(true);
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [dynamicLegend, setDynamicLegend] = useState([]);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTree[0] !== null &&
      dateRangePicTree[1] !== null &&
      initialDataCall
    ) {
      getPictreePhotoShootByAssetTepco();
      getPictreePhotoShootTrendByAssetTepco("day");
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

  useEffect(() => {
    if (photoShootTrendByAsset.length > 0) {
      const trend = photoShootTrendByAsset[0]; // 例: { date:[...], "通常電柱":[...], "ツルツタ電柱":[...] }

      const sums = Object.keys(trend)
        .filter((k) => k !== "date")
        .map((k) => ({
          key: k,
          total: trend[k].reduce((a, b) => a + b, 0),
        }));

      // 降順ソート
      const sorted = sums.sort((a, b) => b.total - a.total);

      // legend はキーの配列だけ
      const legend = sorted.map((item) => item.key);

      setDynamicLegend(legend);
    }
  }, [photoShootTrendByAsset]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée TEPCO</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">通常モード</Typography>
              <Typography variant="body1">アセットタイプ別</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePicker mDate={"2024/04/13"} page="pictree" pictree />
          </Grid>
        </Grid>

        <Grid container spacing={0} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <PhotoShootAssetType company="tepco" />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Grid
              container
              spacing={0}
              direction="row"
              style={{ marginTop: 0, marginRight: 16, marginBottom: 8 }}
              justifyContent="flex-end"
            >
              <Grid item></Grid>
            </Grid>
          </Grid>
        </Grid>

        <>
          <Grid container spacing={1} className={classes.gridSection}>
            <Grid item xs={12} md={12} lg={12}>
              {pageTopLoader ? (
                <div className={classes.loaderBox}>
                  <img
                    className={classes.loaderBarImg}
                    src={`/static/images/loader-bar.gif`}
                  />
                </div>
              ) : chartState ? (
                photoShootTrendByAsset.length > 0 ? (
                  <LineChartPictreePhotoShoot
                    legend={dynamicLegend}
                    lblSaveImage={""}
                    xAisData={photoShootTrendByAsset[0]["date"]}
                    seriesData={photoShootTrendByAsset}
                    chartType={"line"}
                    chartConfig={ChartConfig.chartLabelPicTreeAssetTypeNtt}
                    yAxis={[{
                      type: 'value',
                      name: '撮影基数',
                      alignTicks: true,
                      axisLine: {
                        show: true,
                      },
                      axisLabel: {
                        formatter: '{value}'
                      }
                    }]}
                    colorValue={V.genericColorPallette}
                  />
                ) : (
                  <div className={classes.selectGameTxt}>
                    <Chip
                      label="No Data"
                      style={{
                        color: V.textColor,
                        backgroundColor: V.placeholderColor,
                      }}
                    />
                  </div>
                )
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={1} className={classes.gridSection}>
            <Grid item xs={12}>
              <PicTreeTablePhotoSubType
                trendData={photoShootTrendByAsset}
                orderKeys={dynamicLegend}
                chartSize="day"
                loading={pageTopLoader}
              />
            </Grid>
          </Grid>
        </>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeReviewByAssetTypeTepco.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTree: state.page.dateRangePicTree,
  photoShootTrendByAsset: state.pictree.photoShootTrendByAsset,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPictreePhotoShootByAssetTepco: () => dispatch(getPictreePhotoShootByAssetTepco()),
  getPictreePhotoShootTrendByAssetTepco: (param) => dispatch(getPictreePhotoShootTrendByAssetTepco(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeReviewByAssetTypeTepco));
